const constants = {
  search: {
    contentTypes: {
      page: 'page',
      event: 'event',
      allEvents: 'ALL_EVENTS',
      news: 'news',
      contentOnly: 'content',
    },
    preFilters: {
      events: 'events',
      news: 'news',
      content: 'content',
    },
  },
}

export default constants
